import { useSelector } from 'react-redux';
import { NoInternetNinja } from '../../assets/images';
import style from './style.scss'
import { textIdentifier } from '../Common/textIdentifier';

function Modal ()  {
    const refreshPage = ()=>{
        window.location.reload();
     }
     const { userSession } = useSelector((state) => state);
     const language = (userSession && userSession.user && userSession.user.language) || "eng";

    return (
      <div>
        <div className={style['wrapper']}>
            <div className= {style['mainCard']}>
            <div className={style['container-img']}>
          <div className={style['img']} >
            <NoInternetNinja/>
          </div> 
          </div>
          <div className={style['container-info']}>
          <div className={style['message']}>
            <p>{textIdentifier["oops-we-are-having-a-technical-difficulty-here"][language]}<br />{textIdentifier["please-refresh-or-reload"][language]}</p>
          </div>
          <div className={style['button']}>
            <button onClick={refreshPage}>{textIdentifier["refresh"][language]}</button>
          </div>
          </div>
          </div>
        </div>
      </div>
    )
  }


export default Modal